import type {
  Objective,
  ObjectiveStickyTree,
  ObjectiveUpdate,
  StickyReference,
  TreeSticky,
} from "@/model/objective";

import type {
  ServerObjective,
  ServerObjectiveLinkedSticky,
  ServerObjectiveStickyTree,
  ServerTreeSticky,
} from "../serverModel";
import { mapStatusDistribution } from "./mapBackendData";

export function mapObjective(objective: ServerObjective): Objective {
  const mappedObjective = mapPartialObjective(objective);
  return { ...mappedObjective, cards: mappedObjective.cards || [] };
}

/**
 * Similar to mapObjective, but the return value may not have a cards property
 * (used to communicate that the cards property hasn't been updated)
 */
export function mapPartialObjective(objective: ServerObjective): ObjectiveUpdate {
  return {
    id: objective.objective_id,
    text: objective.text,
    description: objective.description,
    bv: objective.bv,
    av: objective.av,
    rag: objective.rag,
    cards: objective.stickies?.map(mapLinkedSticky),
    cardTree: mapCardTree(objective.sticky_tree),
  };
}

function mapLinkedSticky(sticky: ServerObjectiveLinkedSticky): StickyReference {
  return { id: sticky.id, isOrigin: sticky.is_origin };
}

function mapCardTree(tree?: ServerObjectiveStickyTree): ObjectiveStickyTree | undefined {
  if (tree) {
    return {
      cards: tree.stickies.map(mapTreeSticky),
      statusDistribution: mapStatusDistribution(tree.status_distribution),
    };
  }
}

function mapTreeSticky(sticky: ServerTreeSticky): TreeSticky {
  return { id: sticky.id, children: sticky.children.map(mapTreeSticky) };
}
